import { useEffect, useRef } from 'react'

export function usePreviousValue<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>(undefined)
  
  useEffect(() => {
    ref.current = value
  }, [value])
  
  return ref.current as T | undefined
} 